import React from 'react';
import { Link } from 'react-router-dom';
// Icons
import { FaInstagram, FaTiktok, FaYoutube } from 'react-icons/fa';
import { SiX } from 'react-icons/si';

// Constants
import {
  INSTAGRAM_URL,
  X_URL,
  TIKTOK_URL,
  YOUTUBE_URL,
} from '../../utils/Constants';

// Components
import SocialMediaPin from './SocialMediaPin';
import { FooterLinksArray } from '../../utils/data/FooterData';

function SocialMediaCTA() {
  const navigateToSocialMedia = (url) => {
    window.open(url, '_blank');
  };

  const socialMediaPins = [
    {
      serviceName: 'Instagram',
      icon: <FaInstagram size={32} />, // Using React Icon for Instagram
      url: INSTAGRAM_URL,
      background: {
        background:
          'linear-gradient(45deg, #fccc63, #fbad50, #cd486b, #4c68d7)',
      },
    },
    {
      serviceName: 'X (formerly Twitter)',
      icon: <SiX size={32} />, // Using React Icon for X (formerly Twitter)
      url: X_URL,
      background: { background: '#1DA1F2' },
    },
    {
      serviceName: 'TikTok',
      icon: <FaTiktok size={32} />, // Using React Icon for TikTok
      url: TIKTOK_URL,
      background: { background: '#000' },
    },
  ];

  return (
    <section className='grid gap-2 w-fit mx-auto'>
      <div className='grid grid-flow-col gap-2 gap-x-6 w-fit mx-auto'>
        {socialMediaPins.map((pin) => (
          <SocialMediaPin
            key={pin.serviceName}
            serviceName={pin.serviceName}
            icon={pin.icon}
            func={() => navigateToSocialMedia(pin.url)}
            background={pin.background}
          />
        ))}
      </div>
    </section>
  );
}

export default SocialMediaCTA;
